<template>
  <div class="flex justify-center space-x-10">
    <ShareNetwork
      v-for="network in networks"
      :network="network.network"
      :key="network.network"
      :style="{ backgroundColor: network.color }"
      :url="sharing.url"
      :title="sharing.title"
      :description="sharing.description"
      :quote="sharing.quote"
      :hashtags="sharing.hashtags"
      :twitterUser="sharing.twitterUser"
    >
      <span v-if="network.id == 1">
        <!-- Facebook svg icon -->
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
        >
          <path
            id="Icon_metro-facebook"
            data-name="Icon metro-facebook"
            d="M29.238,1.928H7.9A5.333,5.333,0,0,0,2.571,7.262V28.594A5.333,5.333,0,0,0,7.9,33.928H18.571v-14h-4v-4h4v-3a5,5,0,0,1,5-5h5v4h-5a1,1,0,0,0-1,1v3h5.5l-1,4h-4.5v14h6.667a5.333,5.333,0,0,0,5.333-5.334V7.262a5.333,5.333,0,0,0-5.333-5.334Z"
            transform="translate(-2.571 -1.928)"
            fill="#4267b2"
          />
        </svg>
      </span>
       <!-- Skype svg icon -->
       <!--
      <span v-if="network.id == 2">
        <svg
          enable-background="new 0 0 512 512"
          height="38"
          id="Layer_1"
          version="1.1"
          viewBox="0 0 512 512"
          width="38"
          xml:space="preserve"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <g>
            <linearGradient
              gradientTransform="matrix(1 0 0 -1 -41.66 349.04)"
              gradientUnits="userSpaceOnUse"
              id="SVGID_1_"
              x1="61.491"
              x2="653.8826"
              y1="328.2375"
              y2="-264.1542"
            >
              <stop offset="0" style="stop-color: #11a4dc" />
              <stop offset="0.5051" style="stop-color: #0f94c9" />
              <stop offset="1" style="stop-color: #0c82b4" />
            </linearGradient>
            <path
              d="M316.78,251.983c-6.487-4.22-14.41-7.829-23.604-10.772c-9.059-2.908-19.331-5.586-30.491-7.988   c-8.818-2.037-15.246-3.608-19.072-4.68c-3.738-1.024-7.488-2.466-11.108-4.297c-3.484-1.76-6.257-3.844-8.211-6.251   c-1.866-2.26-2.772-4.874-2.772-8.023c0-5.127,2.802-9.453,8.553-13.215c5.969-3.926,14.015-5.904,23.893-5.904   c10.648,0,18.395,1.772,23.039,5.31c4.774,3.632,8.936,8.788,12.374,15.311c2.973,5.115,5.651,8.671,8.229,10.972   c2.772,2.437,6.775,3.691,11.879,3.691c5.621,0,10.377-1.99,14.163-5.91c3.761-3.914,5.657-8.394,5.657-13.327   c0-5.115-1.448-10.413-4.297-15.723c-2.837-5.274-7.358-10.331-13.416-15.075c-6.021-4.703-13.68-8.529-22.774-11.355   c-9.047-2.796-19.866-4.232-32.181-4.232c-15.417,0-29.032,2.149-40.469,6.381c-11.596,4.273-20.608,10.537-26.771,18.583   c-6.216,8.088-9.365,17.489-9.365,27.907c0,10.937,3.008,20.214,8.924,27.636c5.828,7.287,13.798,13.127,23.699,17.341   c9.671,4.103,21.821,7.741,36.148,10.802c10.519,2.207,19.031,4.326,25.294,6.275c6.016,1.89,10.955,4.603,14.728,8.117   c3.573,3.373,5.309,7.641,5.309,13.085c0,6.887-3.32,12.52-10.195,17.206c-7.028,4.803-16.382,7.234-27.79,7.234   c-8.276,0-15.022-1.207-20.025-3.567c-4.968-2.355-8.853-5.363-11.566-8.953c-2.82-3.703-5.475-8.429-7.923-14.039   c-2.196-5.139-4.909-9.124-8.082-11.826c-3.32-2.802-7.411-4.215-12.149-4.215c-5.78,0-10.619,1.801-14.398,5.357   c-3.814,3.585-5.745,7.97-5.745,13.015c0,8.094,2.967,16.476,8.818,24.911c5.804,8.388,13.438,15.157,22.709,20.155   c12.956,6.875,29.573,10.366,49.381,10.366c16.494,0,30.992-2.555,43.088-7.582c12.22-5.074,21.65-12.232,28.019-21.256   c6.404-9.047,9.66-19.419,9.66-30.756c0-9.501-1.884-17.671-5.61-24.293C328.612,261.795,323.378,256.28,316.78,251.983z"
              fill="url(#SVGID_1_)"
            />
            <linearGradient
              gradientTransform="matrix(1 0 0 -1 -41.66 349.04)"
              gradientUnits="userSpaceOnUse"
              id="SVGID_2_"
              x1="61.9769"
              x2="654.3685"
              y1="328.7231"
              y2="-263.6686"
            >
              <stop offset="0" style="stop-color: #11a4dc" />
              <stop offset="0.5051" style="stop-color: #0f94c9" />
              <stop offset="1" style="stop-color: #0c82b4" />
            </linearGradient>
            <path
              d="M348.489,35.511H163.511c-70.692,0-128,57.308-128,128v184.978c0,70.692,57.308,128,128,128h184.978   c70.693,0,128-57.308,128-128V163.511C476.489,92.819,419.182,35.511,348.489,35.511z M320.601,402.633   c-13.68,0-26.547-3.438-37.814-9.483c-8.188,1.513-16.611,2.307-25.247,2.307c-76.176,0-137.912-61.742-137.912-137.918   c0-9.495,0.954-18.778,2.79-27.731c-6.97-11.873-10.99-25.688-10.99-40.445c0-44.183,35.807-79.996,79.984-79.996   c15.634,0,30.227,4.515,42.541,12.285c7.682-1.313,15.558-2.013,23.593-2.013c76.169,0,137.906,61.742,137.906,137.9   c0,10.16-1.089,20.043-3.173,29.603c5.31,10.707,8.3,22.751,8.294,35.513C400.573,366.826,364.771,402.633,320.601,402.633z"
              fill="url(#SVGID_2_)"
            />
          </g>
        </svg>
      </span>
      -->
      <span v-if="network.id === 2">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 4 48 48" width="42px" height="42px"><path fill="#0288D1" d="M42,37c0,2.762-2.238,5-5,5H11c-2.761,0-5-2.238-5-5V11c0-2.762,2.239-5,5-5h26c2.762,0,5,2.238,5,5V37z"/><path fill="#FFF" d="M12 19H17V36H12zM14.485 17h-.028C12.965 17 12 15.888 12 14.499 12 13.08 12.995 12 14.514 12c1.521 0 2.458 1.08 2.486 2.499C17 15.887 16.035 17 14.485 17zM36 36h-5v-9.099c0-2.198-1.225-3.698-3.192-3.698-1.501 0-2.313 1.012-2.707 1.99C24.957 25.543 25 26.511 25 27v9h-5V19h5v2.616C25.721 20.5 26.85 19 29.738 19c3.578 0 6.261 2.25 6.261 7.274L36 36 36 36z"/></svg>
      </span>
      <span v-if="network.id == 3">
        <!-- Twitter svg icon -->
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
        >
          <path
            id="Icon_awesome-twitter-square"
            data-name="Icon awesome-twitter-square"
            d="M28.571,2.25H3.429A3.429,3.429,0,0,0,0,5.679V30.821A3.429,3.429,0,0,0,3.429,34.25H28.571A3.429,3.429,0,0,0,32,30.821V5.679A3.429,3.429,0,0,0,28.571,2.25ZM25.079,13.593c.014.2.014.407.014.607A13.238,13.238,0,0,1,11.764,27.529a13.267,13.267,0,0,1-7.193-2.1,9.869,9.869,0,0,0,1.129.057,9.392,9.392,0,0,0,5.814-2,4.691,4.691,0,0,1-4.379-3.25A5.049,5.049,0,0,0,9.25,20.15a4.685,4.685,0,0,1-3.75-4.6v-.057a4.682,4.682,0,0,0,2.114.593,4.675,4.675,0,0,1-2.086-3.9,4.626,4.626,0,0,1,.636-2.364,13.3,13.3,0,0,0,9.657,4.9,4.695,4.695,0,0,1,7.993-4.279,9.18,9.18,0,0,0,2.971-1.129,4.672,4.672,0,0,1-2.057,2.579,9.323,9.323,0,0,0,2.7-.729A9.861,9.861,0,0,1,25.079,13.593Z"
            transform="translate(0 -2.25)"
            fill="#39a2f2"
          />
        </svg>
      </span>
      <span class="sr-only">{{ network.name }}</span>
    </ShareNetwork>
  </div>
</template>

<script>
export default {
  name: "ShareNetworkComponent",
  props: {
    sharingUrl: {
      type: String,
      default: "https://news.vuejs.org/issues/180",
    },
    sharingTitle: {
      type: String,
      default:
        "Say hi to Vite! A brand new, extremely fast development setup for Vue.",
    },
  },
  data() {
    return {
      sharing: {
        url: this.sharingUrl,
        title: this.sharingTitle,
        description:
          'This week, I’d like to introduce you to "Vite", which means "Fast". It’s a brand new development setup created by Evan You.',
        quote: "The hot reload is so fast it's near instant. - Evan You",
        hashtags: "fitclass,fitness",
        twitterUser: "youyuxi",
      },
      networks: [
        {
          id: 1,
          network: "facebook",
          name: "Facebook",
        },
        // {
        //   id: 2,
        //   network: "skype",
        //   name: "Skype",
        // },
        {
          id: 2,
          network: "linkedin",
          name: "LinkedIn",
        },
        {
          id: 3,
          network: "twitter",
          name: "Twitter",
        },
      ],
    };
  },
};
</script>